/* ─── PuravidaLash Chat Widget ─────────────────────────────────────────── */
(function () {
  'use strict';

  const CONFIG = window.__PV_CHAT_CONFIG__ || {};
  const API_URL = CONFIG.apiUrl || '';
  const API_KEY = typeof CONFIG.apiKey === 'string' ? CONFIG.apiKey.trim() : '';
  const MAX_MESSAGES = CONFIG.maxMessages || 8;
  const COOLDOWN_MS = (CONFIG.cooldownSeconds || 2) * 1000;
  const PRODUCT_STOCK = window.__PV_PRODUCT_STOCK__ || null;
  const CHAT_DEFAULTS = {
    greeting: '👋 ¡Hola! Soy **Pura**, tu asistente de Puravida Lash. ¿En qué puedo ayudarte hoy?',
    suggestions: [
      '¿Qué adhesivo me recomiendas?',
      '¿Cuánto tarda el envío?',
      'Ver productos recomendados',
      'Cuidado de extensiones',
    ],
    inputPlaceholder: 'Escribe tu pregunta...',
  };

  function getJsonHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    if (API_KEY) headers['x-api-key'] = API_KEY;
    return headers;
  }

  function getCustomString(value, defaultValue) {
    if (typeof value !== 'string') return '';
    const trimmed = value.trim();
    if (!trimmed || trimmed === defaultValue) return '';
    return trimmed;
  }

  function getCustomStringList(value, defaultValue) {
    if (!Array.isArray(value)) return [];
    const entries = value
      .filter((item) => typeof item === 'string')
      .map((item) => item.trim())
      .filter(Boolean);
    if (!entries.length) return [];
    if (entries.length === defaultValue.length && entries.every((item, index) => item === defaultValue[index])) return [];
    return entries;
  }

  const CUSTOM_GREETING = getCustomString(CONFIG.greeting, CHAT_DEFAULTS.greeting);
  const CUSTOM_SUGGESTIONS = getCustomStringList(CONFIG.suggestions, CHAT_DEFAULTS.suggestions);
  const CUSTOM_PLACEHOLDER = getCustomString(CONFIG.placeholder, CHAT_DEFAULTS.inputPlaceholder);

  // ─── Product map (handles → per-product personality) ────────────────────────
  const PRODUCT_MAP = {
    'adhesivo-pure-black': {
      name: 'Adhesivo Pure Black',
      greeting: '👋 ¡Hola! El **Pure Black** es nuestro adhesivo estrella — secado en 0.5s y retención de hasta 8 semanas. ¿Te cuento más? 💚',
      suggestions: [
        'Secado en 0.5s — ¿cómo se trabaja tan rápido? ⚡',
        '¿6-8 semanas de retención es real? ⏱️',
        '¿Pure Black o Pure Easy? Ayúdame a elegir',
        '¿Qué producto combina mejor? 💚',
      ],
      bubble: ['Secado 0.5s — ¡para expertas! ⚡', '8 semanas de retención 💪', '¿Es el adhesivo para ti?'],
    },
    'adhesivo-pure-clear': {
      name: 'Adhesivo Pure Clear',
      greeting: '👋 ¡Hola! El **Pure Clear** es 100% transparente e invisible — perfecto para pestañas claras y ojos sensibles. ¿Quieres saber más? 💚',
      suggestions: [
        '¿Por qué elegir un adhesivo transparente? 👁️',
        'Tengo clientas con ojos sensibles — ¿este va bien?',
        '¿Misma retención que el Pure Black?',
        '¿Qué producto combina mejor? 💚',
      ],
      bubble: ['100% invisible — cero rastro 👁️', 'Ideal para ojos sensibles 🤍', '¿Transparente o negro?'],
    },
    'adhesivo-pure-easy': {
      name: 'Adhesivo Pure Easy',
      greeting: '👋 ¡Hola! El **Pure Easy** es ideal si estás empezando — 2-3 segundos de secado para que coloques con calma y sin estrés. ¿Te ayudo? 💚',
      suggestions: [
        'Estoy empezando — ¿este adhesivo es para mí? 🌱',
        '¿2-3 segundos de secado es suficiente?',
        '¿Cuándo paso al Pure Black? 🚀',
        '¿Qué producto combina mejor? 💚',
      ],
      bubble: ['Perfecto para empezar 🌱', '2-3s de secado — sin prisas ✨', '¿Lista para dar el salto?'],
    },
    'pestanas-clasicas': {
      name: 'Pestañas Clásicas',
      greeting: '👋 ¡Hola! Las **Clásicas** son fibra PBT coreana premium con 16 filas por bandeja — el look natural y elegante que más piden las clientas. ¿Te asesoro? 💚',
      suggestions: [
        '¿Qué curvatura queda más natural? C o D 👁️',
        '¿0.12 o 0.15mm? ¿Cuál elijo?',
        '¿Qué adhesivo va mejor con clásicas?',
        '¿Qué adhesivo va mejor con estas pestañas? 💚',
      ],
      bubble: ['16 filas por bandeja 💪', 'Fibra PBT coreana premium ✨', '¿Curvatura C o D?'],
    },
    'pestanas-w': {
      name: 'Pestañas W',
      greeting: '👋 ¡Hola! Las **Pestañas W** dan efecto volumen con la rapidez de las clásicas — ¡la técnica que está arrasando! ¿Quieres saber cómo funcionan? 💚',
      suggestions: [
        '¿Cómo dan efecto volumen sin abanico? 🌟',
        'W vs YY — ¿cuál da más volumen?',
        '¿Para qué nivel son las W?',
        '¿Qué adhesivo va mejor con estas pestañas? 💚',
      ],
      bubble: ['Volumen exprés — sin hacer abanico 🌟', '¡Están arrasando! 🔥', '¿Las has probado?'],
    },
    'pestanas-yy': {
      name: 'Pestañas YY',
      greeting: '👋 ¡Hola! Las **Pestañas YY** dan el efecto volumen ruso pero en la mitad de tiempo — perfectas para optimizar tus servicios. ¿Te interesa? 💚',
      suggestions: [
        'Volumen ruso en la mitad de tiempo — ¿cómo? ✌️',
        'YY vs W — ¿qué diferencia hay?',
        '¿Qué curvatura da el mejor efecto wow?',
        '¿Qué adhesivo va mejor con estas pestañas? 💚',
      ],
      bubble: ['Volumen ruso × 2 velocidad ✌️', '¿YY o W? Te ayudo 💚', '¡El efecto wow está aquí!'],
    },
    'booster': {
      name: 'Booster',
      greeting: '👋 ¡Hola! El **Booster** es el paso 4 del protocolo — lleva la retención al siguiente nivel. Solo para lash artists avanzadas. ¿Quieres saber si es para ti? 💚',
      suggestions: [
        '¿El Booster realmente mejora la retención? 🚀',
        '¿Es obligatorio en el protocolo?',
        '¿Cómo se aplica correctamente?',
        '¿Qué necesito para el protocolo completo? 💚',
      ],
      bubble: ['El secreto de la retención pro 🚀', '¿Lista para el nivel avanzado?', 'Paso 4 del protocolo ✨'],
    },
    'lash-shampoo': {
      name: 'Lash Shampoo',
      greeting: '👋 ¡Hola! El **Lash Shampoo** es el paso 2 del protocolo — limpieza profunda que prepara la pestaña natural para una adhesión perfecta. ¡Imprescindible! 💚',
      suggestions: [
        '¿Por qué el shampoo es clave para la retención? 🧴',
        '¿Cómo lo aplico correctamente?',
        '¿Qué pasa si me salto este paso?',
        '¿Qué necesito para el protocolo completo? 💚',
      ],
      bubble: ['Paso 2 — ¡imprescindible! 🧴', 'Limpieza = retención 💪', '¿Haces el protocolo completo?'],
    },
    'primer': {
      name: 'Primer',
      greeting: '👋 ¡Hola! El **Primer** es el paso 3 del protocolo — equilibra el pH de la pestaña natural para que el adhesivo agarre al máximo. ¿Te explico? 💚',
      suggestions: [
        '¿Qué hace exactamente el Primer? 🧪',
        '¿Primer antes o después del Shampoo?',
        '¿Cuánto mejora la retención con Primer?',
        '¿Qué necesito para el protocolo completo? 💚',
      ],
      bubble: ['pH perfecto = adhesión perfecta 🧪', 'Paso 3 del protocolo ✨', '¿Lo usas en cada servicio?'],
    },
    'removedor': {
      name: 'Removedor',
      greeting: '👋 ¡Hola! El **Removedor** es el paso 1 del protocolo — elimina extensiones anteriores de forma segura, sin GBL y sin gotear. ¿Tienes dudas? 💚',
      suggestions: [
        '¿Qué significa "sin GBL"? ¿Por qué importa? 🛡️',
        '¿Cómo se usa sin que gotee?',
        '¿Cuánto tarda en hacer efecto?',
        '¿Qué necesito para el protocolo completo? 💚',
      ],
      bubble: ['Sin GBL — seguridad primero 🛡️', 'No gotea — trabajo limpio ✨', '¿Conoces nuestro protocolo?'],
    },
    'pinza-pro-1': {
      name: 'Pinza PRO 1',
      greeting: '👋 ¡Hola! La **Pinza PRO 1** es acero japonés de precisión — ideal para aislamiento en técnica clásica. ¿Te cuento más? 💚',
      suggestions: [
        '¿Qué técnica va mejor con la PRO 1? 🔧',
        'Acero japonés vs acero normal — ¿se nota?',
        '¿Qué pinzas necesito para empezar?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['Acero japonés — otra liga 🔧', 'Precisión de aislamiento ✨', '¿Cuál es tu técnica?'],
    },
    'pinza-pro-2': {
      name: 'Pinza PRO 2',
      greeting: '👋 ¡Hola! La **Pinza PRO 2** está diseñada para abanicos de volumen — agarre firme y punta ultrafina. ¿Necesitas asesoría? 💚',
      suggestions: [
        '¿La PRO 2 es buena para volumen ruso? 🔧',
        '¿Diferencia entre PRO 2 y PRO 3?',
        '¿Cómo cuido mis pinzas para que duren?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['Abanicos perfectos con la PRO 2 🔧', 'Punta ultrafina ✨', '¿Haces volumen?'],
    },
    'pinza-pro-3': {
      name: 'Pinza PRO 3',
      greeting: '👋 ¡Hola! La **Pinza PRO 3** es la favorita para mega volumen — máximo control con mínimo esfuerzo. ¿Te interesa? 💚',
      suggestions: [
        '¿PRO 3 para mega volumen? Cuéntame 🔧',
        '¿En qué se diferencia de la PRO 2?',
        '¿Qué set de pinzas me recomiendas?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['La reina del mega volumen 👑', 'Máximo control 🔧', '¿Cuál es tu favorita?'],
    },
    'pinza-pro-4': {
      name: 'Pinza PRO 4',
      greeting: '👋 ¡Hola! La **Pinza PRO 4** es versátil — funciona tanto para clásicas como para volumen. El comodín del kit. ¿Te asesoro? 💚',
      suggestions: [
        '¿La PRO 4 vale para todo? 🔧',
        '¿Es buena opción si solo quiero una pinza?',
        '¿Cómo la mantengo en perfecto estado?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['La todoterreno del kit 🔧', 'Clásicas + volumen ✨', '¿Solo quieres una? Esta es.'],
    },
    'pinza-pro-5': {
      name: 'Pinza PRO 5',
      greeting: '👋 ¡Hola! La **Pinza PRO 5** tiene curvatura ergonómica para sesiones largas sin fatiga. Tus manos te lo agradecerán. ¿Te cuento? 💚',
      suggestions: [
        '¿Curvatura ergonómica para qué sirve? 🔧',
        '¿La PRO 5 reduce la fatiga en manos?',
        '¿Para qué técnica es mejor?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['Cero fatiga en sesiones largas 🔧', 'Ergonómica de verdad ✨', '¿Sesiones de +2h?'],
    },
    'pinza-pro-6': {
      name: 'Pinza PRO 6',
      greeting: '👋 ¡Hola! La **Pinza PRO 6** es de precisión extrema — para las que buscan perfección en cada pestaña. ¿Te interesa? 💚',
      suggestions: [
        '¿Qué hace especial a la PRO 6? 🔧',
        '¿Para qué nivel es esta pinza?',
        '¿Set completo o pinzas sueltas?',
        '¿Qué pinza me recomiendas? 💚',
      ],
      bubble: ['Precisión extrema 🎯', 'Para perfeccionistas 🔧', '¿Buscas lo mejor?'],
    },
    'premadefan-3d': {
      name: 'Premade Fans 3D',
      greeting: '👋 ¡Hola! Los **Premade Fans 3D** dan volumen natural sin hacer abanicos — perfectos si estás empezando con volumen. ¿Te ayudo? 💚',
      suggestions: [
        '¿3D para un look natural con volumen? ✨',
        '¿Necesito experiencia para usar premade fans?',
        '¿Qué adhesivo uso con los 3D?',
        '¿Qué adhesivo uso con premade fans? 💚',
      ],
      bubble: ['Volumen natural sin complicarte ✨', '¿Primera vez con premade? 🌱', '¡3D para empezar!'],
    },
    'premadefan-4d': {
      name: 'Premade Fans 4D',
      greeting: '👋 ¡Hola! Los **Premade Fans 4D** son el equilibrio perfecto: volumen visible pero sin exagerar. Los más vendidos en premade. ¿Quieres saber por qué? 💚',
      suggestions: [
        '¿Por qué los 4D son los más vendidos? 🔥',
        '4D vs 3D — ¿cuánta diferencia hay?',
        '¿Combinan bien con técnica mixta?',
        '¿Qué adhesivo uso con premade fans? 💚',
      ],
      bubble: ['Los más vendidos en premade 🔥', '4D = equilibrio perfecto ✨', '¿Qué efecto buscas?'],
    },
    'premadefan-6d': {
      name: 'Premade Fans 6D',
      greeting: '👋 ¡Hola! Los **Premade Fans 6D** dan ese efecto WOW de volumen ruso — sin pasar horas haciendo abanicos. ¿Te cuento? 💚',
      suggestions: [
        'Efecto volumen ruso sin hacer abanicos — ¿en serio? 🤩',
        '¿6D queda muy exagerado?',
        '¿Qué adhesivo aguanta los 6D?',
        '¿Qué adhesivo uso con premade fans? 💚',
      ],
      bubble: ['Efecto WOW garantizado 🤩', 'Volumen ruso exprés ✨', '¿Lista para el cambio?'],
    },
    'premadefan-10d': {
      name: 'Premade Fans 10D',
      greeting: '👋 ¡Hola! Los **Premade Fans 10D** son máximo volumen — efecto mega drama para las clientas que quieren mirada impactante. ¿Es lo que buscas? 💚',
      suggestions: [
        '¿10D no pesará demasiado? 🤔',
        '¿Para qué tipo de clienta son los 10D?',
        '¿Qué adhesivo necesito para tanto volumen?',
        '¿Qué adhesivo uso con premade fans? 💚',
      ],
      bubble: ['Mega volumen — impacto total 💥', '¿Tu clienta quiere drama? 👁️', '10D = mirada WOW'],
    },
    'premadefan-14d': {
      name: 'Premade Fans 14D',
      greeting: '👋 ¡Hola! Los **Premade Fans 14D** son el máximo volumen que existe — efecto ultra dramático para ocasiones especiales o clientas que quieren el look más intenso. ¿Quieres saber más? 💚',
      suggestions: [
        '¿14D para el día a día o solo eventos? 💎',
        '¿Cómo se manejan con tanto volumen?',
        '¿Qué clientas piden 14D?',
        '¿Qué adhesivo uso con premade fans? 💚',
      ],
      bubble: ['Ultra drama — el máximo volumen 💎', '¡Para las más atrevidas! 🔥', '¿Eventos especiales?'],
    },
  };

  // ─── Collection map (handles → unique messages) ─────────────────────────────
  const COLLECTION_MAP = {
    'adhesivos': {
      name: 'Adhesivos',
      greeting: '👋 ¡Hola! Estás en nuestra colección de adhesivos — tenemos 3 fórmulas diferentes según tu nivel y técnica. ¿Te ayudo a elegir el tuyo? 💚',
      suggestions: [
        '¿Cuál es el adhesivo nº1 en retención? 💧',
        'Soy principiante — ¿cuál me va mejor? 🌱',
        'Pure Black vs Pure Clear vs Pure Easy',
        '¿Cuál encaja mejor con mi técnica? 💚',
      ],
      bubble: ['3 fórmulas, 3 niveles 💧', '¿Cuál es el tuyo?', 'Te ayudo a elegir 💚'],
    },
    'pestanas-clasicas': {
      name: 'Pestañas Clásicas',
      greeting: '👋 ¡Hola! Las clásicas son el look más pedido — naturales, elegantes y con fibra PBT coreana premium. ¿Necesitas ayuda con curvatura o grosor? 💚',
      suggestions: [
        '¿Curvatura C o D para un look natural? 👁️',
        '¿0.12mm o 0.15mm? ¿Cuál elijo?',
        '16 filas por bandeja — ¿cuántas necesito al mes?',
        '¿Qué adhesivo combina mejor? 💚',
      ],
      bubble: ['Las más pedidas por las clientas 👁️', 'Fibra PBT coreana ✨', '¿C, D, L o M?'],
    },
    'pestanas-w': {
      name: 'Pestañas W',
      greeting: '👋 ¡Hola! Las W son la revolución del volumen exprés — efecto espectacular con la rapidez de las clásicas. ¿Quieres saber cómo funcionan? 💚',
      suggestions: [
        '¿Cómo dan volumen sin hacer abanicos? 🌟',
        'W vs YY — ¿cuál da más efecto?',
        '¿Para principiantes o avanzadas?',
        '¿Qué adhesivo combina mejor? 💚',
      ],
      bubble: ['Volumen exprés sin abanico 🌟', '¡La técnica del momento! 🔥', '¿Las has probado?'],
    },
    'pestanas-yy': {
      name: 'Pestañas YY',
      greeting: '👋 ¡Hola! Las YY te dan efecto volumen ruso en la mitad de tiempo — más servicios al día, más ingresos. ¿Te cuento cómo? 💚',
      suggestions: [
        'Volumen ruso en la mitad de tiempo — ¿cómo? ✌️',
        'YY vs W — ¿qué diferencia hay?',
        '¿Qué curvatura queda mejor?',
        '¿Qué adhesivo combina mejor? 💚',
      ],
      bubble: ['Más servicios al día = más ingresos 💰', 'Volumen ruso × 2 velocidad ✌️', '¿Optimizas tu tiempo?'],
    },
    'pestanas': {
      name: 'Pestañas',
      greeting: '👋 ¡Hola! Tenemos clásicas, W, YY y premade fans — cada una para un estilo y técnica diferente. ¿Te ayudo a encontrar las tuyas? 💚',
      suggestions: [
        '¿Clásicas, W, YY o premade? Guíame 👁️',
        '¿Cuáles son las más vendidas?',
        '¿Qué pestañas para un look natural?',
        '¿Qué pestañas me recomiendas? 💚',
      ],
      bubble: ['4 tipos — ¿cuál es el tuyo? 👁️', 'Las más vendidas del mes 🔥', '¿Natural o drama?'],
    },
    'premade-fan': {
      name: 'Premade Fans',
      greeting: '👋 ¡Hola! Los premade fans te ahorran hasta un 40% del tiempo — volumen profesional sin hacer abanicos. Desde 3D hasta 14D. ¿Cuál necesitas? 💚',
      suggestions: [
        '3D, 4D, 6D, 10D o 14D — ¿cuál elijo? ✨',
        '¿Los premade fans son para principiantes?',
        '¿Cuánto tiempo ahorro con premade fans?',
        '¿Qué adhesivo combina mejor? 💚',
      ],
      bubble: ['Ahorra 40% de tiempo ⏱️', 'De 3D a 14D — ¿qué efecto quieres? ✨', '¡Para todos los niveles!'],
    },
    'premade-fans': {
      name: 'Premade Fans',
      greeting: '👋 ¡Hola! Los premade fans te ahorran hasta un 40% del tiempo — volumen profesional sin hacer abanicos. Desde 3D hasta 14D. ¿Cuál necesitas? 💚',
      suggestions: [
        '3D, 4D, 6D, 10D o 14D — ¿cuál elijo? ✨',
        '¿Los premade fans son para principiantes?',
        '¿Cuánto tiempo ahorro con premade fans?',
        '¿Qué adhesivo combina mejor? 💚',
      ],
      bubble: ['Ahorra 40% de tiempo ⏱️', 'De 3D a 14D — ¿qué efecto quieres? ✨', '¡Para todos los niveles!'],
    },
    'pre-tratamiento': {
      name: 'Pre-Tratamiento',
      greeting: '👋 ¡Hola! El protocolo de pre-tratamiento es el secreto de las que tienen retención de 6-8 semanas. 4 pasos, cero despegues. ¿Te lo explico? 💚',
      suggestions: [
        'El protocolo de 4 pasos que duplica tu retención 🧴',
        '¿Cuánto cuesta el kit completo?',
        '¿Qué pasa si me salto algún paso?',
        '¿Qué incluye el kit completo? 💚',
      ],
      bubble: ['El secreto de la retención perfecta 🧴', '4 pasos = cero despegues ✨', '¿Haces el protocolo?'],
    },
    'pinzas': {
      name: 'Pinzas',
      greeting: '👋 ¡Hola! Nuestras 6 pinzas PRO son acero japonés — una para cada técnica. La herramienta correcta marca la diferencia. ¿Te asesoro? 💚',
      suggestions: [
        '¿Qué pinza necesito para mi técnica? 🔧',
        'Acero japonés — ¿se nota la diferencia?',
        '¿Set completo o compro por separado?',
        '¿Qué pinza necesito para mi técnica? 💚',
      ],
      bubble: ['6 pinzas PRO — una para cada técnica 🔧', 'Acero japonés premium ✨', '¿Cuál necesitas?'],
    },
    'mas-vendidos': {
      name: 'Más Vendidos',
      greeting: '👋 ¡Hola! Estás viendo lo que más compran las profesionales — los productos que funcionan de verdad. ¿Te ayudo a elegir? 💚',
      suggestions: [
        '¿Por qué estos son los más vendidos? 🔥',
        '¿Cuál es el kit básico para empezar?',
        '¿Qué compran las lash artists con más experiencia?',
        '¿Cuál me recomiendas para empezar? 💚',
      ],
      bubble: ['Lo que eligen las pros 🔥', '¡Los favoritos del mes! ✨', '¿Necesitas recomendación?'],
    },
    'ofertas': {
      name: 'Ofertas',
      greeting: '👋 ¡Hola! Buena idea mirar las ofertas — te ayudo a encontrar productos destacados y combinaciones útiles para tu trabajo. ¿Qué necesitas reponer? 💚',
      suggestions: [
        '¿Qué productos merece la pena reponer? 🌸',
        '¿Qué 4 productos me recomiendas?',
        '¿Qué productos combinan mejor?',
        '¡Quiero armar mi pedido perfecto!',
      ],
      bubble: ['Productos destacados 🌸', '¿Qué necesitas reponer?', '¿Armamos tu pedido?'],
    },
    'extensiones': {
      name: 'Extensiones',
      greeting: '👋 ¡Hola! Aquí tienes todo lo que necesitas en extensiones — desde pestañas hasta adhesivos y herramientas. ¿Por dónde quieres empezar? 💚',
      suggestions: [
        '¿Qué necesito para empezar con extensiones? 🌱',
        '¿Cuáles son las pestañas más vendidas?',
        '¿Kit completo para principiantes?',
        '¿Qué kit completo me recomiendas? 💚',
      ],
      bubble: ['Todo para extensiones en un sitio ✨', '¿Por dónde empezar? 🌱', 'Te ayudo a elegir 💚'],
    },
  };

  // ─── Page map (handles → unique messages) ────────────────────────────────────
  const PAGE_MAP = {
    'faq': {
      name: 'Preguntas Frecuentes',
      greeting: '👋 ¡Hola! ¿No encuentras lo que buscas en las FAQ? Pregúntame directamente — te respondo al momento 💚',
      suggestions: [
        '¿Cuánto tarda el envío a mi zona? 📦',
        '¿Cómo devuelvo un producto?',
        '¿Qué adhesivo me recomiendas para empezar?',
        '¿Hay oferta activa ahora? 🌸',
      ],
      bubble: ['¿No encuentras tu respuesta? 💬', 'Pregúntame lo que quieras 💚', 'Te ayudo al momento 💚'],
    },
    'preguntas': {
      name: 'Preguntas Frecuentes',
      greeting: '👋 ¡Hola! ¿No encuentras lo que buscas en las FAQ? Pregúntame directamente — te respondo al momento 💚',
      suggestions: [
        '¿Cuánto tarda el envío a mi zona? 📦',
        '¿Cómo devuelvo un producto?',
        '¿Qué adhesivo me recomiendas para empezar?',
        '¿Hay oferta activa ahora? 🌸',
      ],
      bubble: ['¿No encuentras tu respuesta? 💬', 'Pregúntame lo que quieras 💚', 'Te ayudo al momento 💚'],
    },
    'contacto': {
      name: 'Contacto',
      greeting: '👋 ¡Hola! ¿Necesitas contactarnos? Por WhatsApp respondemos en minutos — o pregúntame aquí y te ayudo ahora mismo 💚',
      suggestions: [
        'Quiero hablar por WhatsApp 💬',
        'Tengo un problema con mi pedido',
        '¿En cuánto tiempo respondéis?',
        '¿Tenéis tienda física en España?',
      ],
      bubble: ['WhatsApp — respuesta en minutos 💬', '¿Problema con tu pedido?', 'Estoy aquí para ti 💚'],
    },
    'contact': {
      name: 'Contacto',
      greeting: '👋 ¡Hola! ¿Necesitas contactarnos? Por WhatsApp respondemos en minutos — o pregúntame aquí y te ayudo ahora mismo 💚',
      suggestions: [
        'Quiero hablar por WhatsApp 💬',
        'Tengo un problema con mi pedido',
        '¿En cuánto tiempo respondéis?',
        '¿Tenéis tienda física en España?',
      ],
      bubble: ['WhatsApp — respuesta en minutos 💬', '¿Problema con tu pedido?', 'Estoy aquí para ti 💚'],
    },
    'sobre-nosotros': {
      name: 'Sobre Nosotros',
      greeting: '👋 ¡Hola! Puravida Lash nació en 2023 tras probar 89 productos y quedarnos solo con los 11 mejores. Calidad sin atajos. ¿Quieres conocernos mejor? 💚',
      suggestions: [
        '¿Por qué probasteis 89 productos? 🔬',
        '¿Qué hace diferente a Puravida Lash?',
        '¿De dónde son vuestros productos?',
        '¡Quiero ver los productos! 🌸',
      ],
      bubble: ['89 probados, 11 elegidos 🔬', 'Calidad sin atajos ✨', '¿Quieres conocernos?'],
    },
    'profesionales': {
      name: 'Profesionales',
      greeting: '👋 ¡Hola! ¿Eres profesional de las extensiones? Tenemos programa de colaboradoras con kit gratis mensual y descuentos mayoristas desde 25 uds. ¿Te interesa? 💚',
      suggestions: [
        '¿Cómo funciona el programa de colaboradoras? 🤝',
        '¿Kit gratis cada mes? ¡Cuéntame!',
        '¿Precios mayoristas desde cuántas unidades?',
        '¿Qué descuentos tenéis para profesionales?',
      ],
      bubble: ['Kit gratis cada mes 🎁', 'Descuentos para pros 💰', '¿Eres profesional?'],
    },
    'colaboradoras': {
      name: 'Colaboradoras',
      greeting: '👋 ¡Hola! El programa de colaboradoras incluye kit gratis cada mes + código de descuento del 10% para tus seguidoras. ¿Quieres unirte? 💚',
      suggestions: [
        '¿Qué incluye el kit gratis mensual? 🎁',
        '¿Cómo funciona el código del 10%?',
        '¿Qué necesito para ser colaboradora?',
        '¿Cuántas colaboradoras tenéis?',
      ],
      bubble: ['Kit gratis CADA mes 🎁', '10% para tus seguidoras 💰', '¿Te unes?'],
    },
    'mayorista': {
      name: 'Mayorista',
      greeting: '👋 ¡Hola! Nuestro programa mayorista empieza desde 25 unidades con descuentos exclusivos. ¿Te cuento las condiciones? 💚',
      suggestions: [
        '¿Desde cuántas unidades hay descuento? 📦',
        '¿Qué descuento tenéis por volumen?',
        '¿Puedo pedir marca blanca?',
        '¿Cómo hago mi primer pedido mayorista?',
      ],
      bubble: ['Descuentos desde 25 uds 📦', 'Marca blanca disponible ✨', '¿Hablamos de mayorista?'],
    },
  };

  // ─── Blog article map (handles → unique messages) ───────────────────────────
  const BLOG_MAP = {
    'aftercare-cuidado-extensiones-pestanas': {
      name: 'Aftercare de Extensiones',
      greeting: '👋 ¡Hola! El aftercare es lo que marca la diferencia entre una retención de 3 semanas y una de 8. ¿Quieres saber qué productos te ayudan? 💚',
      suggestions: [
        '¿Qué productos necesita mi clienta en casa? 🏠',
        '¿El Lash Shampoo sirve para aftercare?',
        '¿Cada cuánto deben venir a retoques?',
        '¿Qué kit aftercare recomiendas? 💚',
      ],
      bubble: ['Aftercare = retención 💪', '¿Tus clientas cuidan sus pestañas?', 'Te ayudo con el kit 💚'],
    },
    'como-elegir-adhesivo-extensiones-pestanas': {
      name: 'Cómo Elegir Adhesivo',
      greeting: '👋 ¡Hola! Elegir el adhesivo correcto es la decisión más importante — te puede cambiar la retención y la velocidad de trabajo. ¿Te ayudo a elegir? 💚',
      suggestions: [
        '¿Pure Black, Clear o Easy? Ayúdame a decidir 💧',
        '¿Qué adhesivo para mi nivel de experiencia?',
        '¿Influye la humedad de mi zona?',
        '¿Qué adhesivo debería probar? 💚',
      ],
      bubble: ['El adhesivo lo cambia todo 💧', '¿Cuál es tu nivel? 🌱', '3 opciones — te ayudo 💚'],
    },
    'errores-lash-artist-principiante': {
      name: 'Errores de Principiantes',
      greeting: '👋 ¡Hola! Todos hemos cometido estos errores al empezar — lo importante es saber cómo evitarlos. ¿Necesitas ayuda con algo? 💚',
      suggestions: [
        '¿Cuál es el error más común en principiantes? 🌱',
        '¿Qué productos evitan los despegues?',
        '¿El protocolo de pre-tratamiento es tan importante?',
        '¿Qué kit recomiendas para empezar? 💚',
      ],
      bubble: ['Los 10 errores que todos cometemos 🌱', '¿Estás empezando?', 'Te ayudo con tu kit 💚'],
    },
    'guia-adhesivos-extensiones-pestanas': {
      name: 'Guía de Adhesivos',
      greeting: '👋 ¡Hola! Esta guía te lo explica todo sobre adhesivos — pero si tienes una duda concreta, pregúntame y te respondo al momento 💚',
      suggestions: [
        '¿Cuánto dura un adhesivo abierto? ⏱️',
        '¿Cómo conservo el adhesivo correctamente?',
        '¿Por qué se me despegan las extensiones?',
        '¿Qué adhesivo me recomiendas? 💚',
      ],
      bubble: ['Todo sobre adhesivos 💧', '¿Problemas de retención?', '¡Pregúntame! 💚'],
    },
    'precios-extensiones-pestanas-como-cobrar': {
      name: 'Precios y Cómo Cobrar',
      greeting: '👋 ¡Hola! Saber cuánto cobrar es clave para tu negocio — y elegir buenos productos te ayuda a justificar precios premium. ¿Hablamos? 💚',
      suggestions: [
        '¿Cuánto debería cobrar por un servicio? 💰',
        '¿Productos premium = precios más altos?',
        '¿Cómo calculo mis costes por servicio?',
        '¿Cómo calculo mis costes por servicio? 💚',
      ],
      bubble: ['Cobra lo que vales 💰', '¿Calculas bien tus costes?', 'Productos top = precios top ✨'],
    },
    'protocolo-higiene-salon-pestanas': {
      name: 'Protocolo de Higiene',
      greeting: '👋 ¡Hola! La higiene en el salón no es opcional — es lo que genera confianza y repite clientas. ¿Conoces nuestros productos de pre-tratamiento? 💚',
      suggestions: [
        '¿Qué productos necesito para un protocolo higiénico? 🧴',
        '¿El Removedor es seguro sin GBL?',
        '¿Cada cuánto desinfecto las pinzas?',
        '¿Qué kit de higiene necesito? 💚',
      ],
      bubble: ['Higiene = confianza = clientas 🧴', '¿Protocolo completo?', 'Te ayudo con el kit 💚'],
    },
    'tendencias-extensiones-pestanas-2026-visagismo-mapeo': {
      name: 'Tendencias 2026',
      greeting: '👋 ¡Hola! Wet Look, Cloud Volume, Foxy Eyes... las tendencias 2026 están aquí. ¿Quieres saber qué productos necesitas para cada una? 💚',
      suggestions: [
        '¿Qué productos necesito para Wet Look? 🌊',
        '¿Cómo se consigue el efecto Cloud Volume?',
        '¿Qué pestañas para Foxy Eyes?',
        '¿Qué productos necesito para estas tendencias? 💚',
      ],
      bubble: ['Wet Look — la tendencia del año 🌊', '¿Ofreces Foxy Eyes? 🦊', 'Tendencias 2026 ✨'],
    },
    'tipos-extensiones-pestanas-clasicas-volumen-yy-w': {
      name: 'Tipos de Extensiones',
      greeting: '👋 ¡Hola! Clásicas, Volumen, YY, W — cada técnica tiene sus pestañas ideales. ¿Te ayudo a elegir las tuyas? 💚',
      suggestions: [
        '¿Clásicas o volumen para empezar? 👁️',
        '¿Qué diferencia hay entre YY y W?',
        '¿Premade fans cuentan como volumen?',
        '¿Qué pestañas me recomiendas? 💚',
      ],
      bubble: ['4 técnicas — ¿cuál dominas? 👁️', '¿Quieres aprender una nueva?', 'Te ayudo a elegir 💚'],
    },
  };

  function getCurrentProduct() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    const handle = match[1];
    const data = PRODUCT_MAP[handle];
    return data ? { handle, ...data } : null;
  }

  function getCurrentCollection() {
    const path = window.location.pathname;
    const match = path.match(/\/collections\/([^/?#]+)/);
    if (!match) return null;
    const handle = match[1];
    const data = COLLECTION_MAP[handle];
    return data ? { handle, ...data } : null;
  }

  function getCurrentPage() {
    const path = window.location.pathname;
    const match = path.match(/\/pages\/([^/?#]+)/);
    if (!match) return null;
    const handle = match[1];
    const data = PAGE_MAP[handle];
    return data ? { handle, ...data } : null;
  }

  function getCurrentBlogArticle() {
    const path = window.location.pathname;
    const match = path.match(/\/blogs\/[^/]+\/([^/?#]+)/);
    if (!match) return null;
    const handle = match[1];
    const data = BLOG_MAP[handle];
    return data ? { handle, ...data } : null;
  }

  // Sugerencias dinámicas según la página actual
  function getPageSuggestions() {
    // ── Producto específico ──────────────────────────────────────────────────
    const product = getCurrentProduct();
    if (product) {
      return product.suggestions || [
        `Cuéntame más sobre ${product.name} 💬`,
        '¿Cuánto tarda en llegar? 📦',
        '¡Envío gratis desde 50€!',
        'Ver productos recomendados 🌸',
      ];
    }

    // ── Colección específica ─────────────────────────────────────────────────
    const collection = getCurrentCollection();
    if (collection) {
      return collection.suggestions;
    }

    // ── Página estática específica ───────────────────────────────────────────
    const page = getCurrentPage();
    if (page) {
      return page.suggestions;
    }

    // ── Blog article específico ──────────────────────────────────────────────
    const article = getCurrentBlogArticle();
    if (article) {
      return article.suggestions;
    }

    const path = window.location.pathname;

    // ── Producto individual (genérico) ─────────────────────────────────────
    if (path.includes('/products/')) {
      return [
        '¿Este producto es lo que necesitas? Te asesoro 💬',
        '¡Envío gratis a partir de 50€! 📦',
        'Política de devolución sin complicaciones',
        '¿Qué producto complementario necesito? 🌸',
      ];
    }

    // ── Carrito / Checkout ─────────────────────────────────────────────────
    if (path.includes('/cart') || path.includes('/checkout')) {
      return [
        '¿Te falta algo? Mira si llegas al envío gratis 📦',
        '¿Has aplicado tu código de descuento? 🎁',
        '¿Necesitas añadir algún básico al pedido? 🌸',
        '¿Dudas con el envío a tu zona?',
      ];
    }

    // ── Blog / Academia (fallback general para artículos no mapeados) ──────
    if (path.includes('/blogs/') || path.includes('/articles/')) {
      return [
        '¿Qué productos necesito para aplicar esto? 💡',
        '¿Tienes más artículos sobre este tema?',
        'Arma mi kit según lo que estoy leyendo',
        '¿Qué producto necesitas para aplicar esto? 🌸',
      ];
    }

    // ── Home / default ─────────────────────────────────────────────────────
    return CUSTOM_SUGGESTIONS.length ? CUSTOM_SUGGESTIONS : CHAT_DEFAULTS.suggestions;
  }

  const SUGGESTIONS = getPageSuggestions();
  function getGreeting() {
    const product = getCurrentProduct();
    if (product) return product.greeting;

    const collection = getCurrentCollection();
    if (collection) return collection.greeting;

    const page = getCurrentPage();
    if (page) return page.greeting;

    const article = getCurrentBlogArticle();
    if (article) return article.greeting;

    return CUSTOM_GREETING || CHAT_DEFAULTS.greeting;
  }
  const WHATSAPP = CONFIG.whatsapp || '+34696673724';

  function buildWhatsAppUrl(customContext) {
    const waNum = WHATSAPP.replace(/\D/g, '');
    const msgsEl = document.getElementById('pv-chat-messages');
    const lastUserMsg = msgsEl ? Array.from(msgsEl.querySelectorAll('.pv-msg.pv-user')).pop() : null;
    const context = customContext || (lastUserMsg ? lastUserMsg.textContent.trim().slice(0, 120) : '');
    const waText = encodeURIComponent(
      context
        ? `Hola, vengo del chat de la web. Estaba preguntando sobre: "${context}". ¿Me ayudáis? 😊`
        : 'Hola, vengo del chat de la web y necesito más ayuda 😊'
    );
    return `https://wa.me/${waNum}?text=${waText}`;
  }

  const WELCOME_CODE = CONFIG.welcomeCode || 'BIENVENIDA5';
  const WELCOME_DISCOUNT = CONFIG.welcomeDiscount || '5€';
  const UI_COPY = {
    headerName: 'Pura · Asistente Puravida Lash',
    statusAvailable: 'Disponible 24h',
    statusTyping: 'Escribiendo...',
    typing: 'Pura está escribiendo...',
    inputPlaceholder: CUSTOM_PLACEHOLDER || CHAT_DEFAULTS.inputPlaceholder,
    footer: 'La IA puede equivocarse · No compartas datos personales o sensibles',
    mascotGift: '🎁 ¡Tengo un regalo para ti!',
  };

  if (!API_URL) {
    console.warn('[PV Chat] apiUrl no configurada.');
    return;
  }
  if (!API_KEY) {
    console.warn('[PV Chat] apiKey no configurada; el backend puede rechazar la solicitud.');
  }

  // ─── Session ID para Supabase ─────────────────────────────────────────────
  const SESSION_ID_KEY = 'pv_session_id';
  function getSessionId() {
    let id = sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now();
      sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  }
  const SESSION_ID = getSessionId();

  // ─── Estado ──────────────────────────────────────────────────────────────
  let isOpen = false;
  let isStreaming = false;
  let lastSendTime = 0;
  let openedFromMascota = false;
  let chatOpener = null;
  let conversationId = sessionStorage.getItem('pv_conversation_id') || null;

  // ─── Persistencia: sessionStorage para historial/sesión; localStorage solo flags no sensibles ──
  const HISTORY_KEY = 'pv_history';
  const HISTORY_TS_KEY = 'pv_history_ts';
  const LAST_PAGE_KEY = 'pv_last_page';
  const CHAT_OPEN_KEY = 'pv_chat_open';
  const HISTORY_TTL = 30 * 60 * 1000; // 30 minutos

  function clearLegacyLocalHistory() {
    localStorage.removeItem(HISTORY_KEY);
    localStorage.removeItem(HISTORY_TS_KEY);
  }
  clearLegacyLocalHistory();

  // C: regalo y mascota en localStorage (persisten entre sesiones)
  const REGALO_KEY = 'pv_regalo_visto';
  const MASCOTA_KEY = 'pv_mascota_dismissed';
  // Migrar valores de sessionStorage a localStorage (one-time)
  if (!localStorage.getItem(REGALO_KEY) && sessionStorage.getItem(REGALO_KEY)) {
    localStorage.setItem(REGALO_KEY, '1');
    sessionStorage.removeItem(REGALO_KEY);
  }
  if (!localStorage.getItem(MASCOTA_KEY) && sessionStorage.getItem(MASCOTA_KEY)) {
    localStorage.setItem(MASCOTA_KEY, '1');
    sessionStorage.removeItem(MASCOTA_KEY);
  }

  // E: History en sessionStorage con TTL
  function loadHistory() {
    try {
      var ts = parseInt(sessionStorage.getItem(HISTORY_TS_KEY) || '0', 10);
      if (Date.now() - ts > HISTORY_TTL) {
        sessionStorage.removeItem(HISTORY_KEY);
        sessionStorage.removeItem(HISTORY_TS_KEY);
        return [];
      }
      return JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]');
    } catch (_) {
      sessionStorage.removeItem(HISTORY_KEY);
      sessionStorage.removeItem(HISTORY_TS_KEY);
      return [];
    }
  }
  function saveHistory() {
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    sessionStorage.setItem(HISTORY_TS_KEY, String(Date.now()));
  }
  const history = loadHistory();

  function toApiMessage(m) {
    var content = typeof m.content === 'string' ? m.content : '';
    if (m.role === 'assistant') return { role: 'assistant', content };
    if (m.role === 'context') {
      return { role: 'user', content: `Contexto de navegación no verificado: ${content}` };
    }
    return { role: 'user', content };
  }
  function getUserMessageCount() { return history.filter(m => m.role === 'user').length; }

  // Detectar cambio de página — solo guardar el último contexto, no acumular
  const currentPath = window.location.pathname;
  const lastPage = sessionStorage.getItem(LAST_PAGE_KEY);
  const PAGE_CONTEXT_KEY = 'pv_page_context';
  if (lastPage && lastPage !== currentPath && history.length > 0) {
    const product = getCurrentProduct();
    const collection = getCurrentCollection();
    const page = getCurrentPage();
    const article = getCurrentBlogArticle();
    const context = product || collection || page || article;
    if (context) {
      // Guardar solo el último contexto — se eliminan los anteriores del historial
      const filtered = history.filter((m) => m.role !== 'context');
      history.length = 0;
      history.push(...filtered);
      history.push({
        role: 'context',
        content: `[La clienta ha navegado a: ${context.name}]`,
        displayContent: `Veo que ahora estás mirando **${context.name}**. ¿Tienes alguna pregunta? 💚`,
      });
      saveHistory();
    }
  }
  sessionStorage.setItem(LAST_PAGE_KEY, currentPath);

  // ─── DOM ─────────────────────────────────────────────────────────────────
  const btn = document.getElementById('pv-chat-btn');
  const badge = document.getElementById('pv-chat-badge');
  const win = document.getElementById('pv-chat-window');
  const msgs = document.getElementById('pv-chat-messages');
  const form = document.getElementById('pv-chat-form');
  const input = document.getElementById('pv-chat-input');
  const sendBtn = document.getElementById('pv-chat-send');
  const suggestionsEl = document.getElementById('pv-suggestions');
  const closeBtn = document.getElementById('pv-chat-close');
  const clearBtn = document.getElementById('pv-chat-clear');

  if (!btn || !win || !msgs || !form || !input) return;

  function hydrateChatShell() {
    const nameEl = document.querySelector('#pv-chat-header .pv-name');
    const statusEl = document.querySelector('#pv-chat-header .pv-status');
    const footerEl = document.getElementById('pv-chat-footer');
    const mascotTitle = document.querySelector('#pv-mascota-bubble .pv-mb-title');

    if (nameEl && !nameEl.textContent.trim()) nameEl.textContent = UI_COPY.headerName;
    if (statusEl && !statusEl.textContent.trim()) statusEl.textContent = UI_COPY.statusAvailable;
    if (footerEl && !footerEl.textContent.trim()) footerEl.textContent = UI_COPY.footer;
    if (input && !input.getAttribute('placeholder')) input.setAttribute('placeholder', UI_COPY.inputPlaceholder);
    if (mascotTitle && !mascotTitle.textContent.trim()) mascotTitle.textContent = UI_COPY.mascotGift;
  }

  hydrateChatShell();

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Convierte markdown básico a HTML seguro
  function renderMarkdown(text) {
    const escaped = escapeHtml(text);
    return escaped
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/`(.+?)`/g, '<code>$1</code>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, function (_, label, url) {
        var isInternal = url.includes('puravidalash.com') || url.startsWith('/');
        if (isInternal) {
          var relUrl = url.replace(/^https?:\/\/[^\/]+/, '');
          return '<a href="' + relUrl + '">' + label + '</a>';
        }
        return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
      })
      // Convertir números de teléfono españoles en enlaces WhatsApp
      .replace(/(\+34[\s\d]{9,13})/g, (match) => {
        const digits = match.replace(/\D/g, '');
        return `<a href="https://wa.me/${digits}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      })
      // Convertir bloques de lista completos con salto de línea extra al inicio
      .replace(/((?:^|\n)- .+(?:\n- .+)*)/g, (match) => {
        const items = match.trim().replace(/^- /gm, '• ');
        return '\n' + items;
      })
      .replace(/\n{2,}/g, '<br><br>')
      .replace(/\n/g, '<br>');
  }

  function scrollToBottom(force = false) {
    if (force) {
      msgs.scrollTop = msgs.scrollHeight;
      return;
    }
    const threshold = 50;
    const atBottom = msgs.scrollHeight - msgs.scrollTop - msgs.clientHeight < threshold;
    if (atBottom) msgs.scrollTop = msgs.scrollHeight;
  }

  function addFeedback(msgDiv, msgIndex) {
    const fb = document.createElement('div');
    fb.className = 'pv-feedback';
    fb.innerHTML = '<button class="pv-fb-btn" data-val="1" aria-label="Útil">👍</button><button class="pv-fb-btn" data-val="-1" aria-label="No útil">👎</button>';
    fb.querySelectorAll('.pv-fb-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const val = parseInt(btn.dataset.val, 10);
        fb.innerHTML = val === 1 ? '<span class="pv-fb-done">¡Gracias! 💚</span>' : '<span class="pv-fb-done">Gracias, lo mejoraremos.</span>';
        // Enviar feedback al backend
        if (conversationId) {
          fetch(`${API_URL}/api/chat/feedback`, {
            method: 'POST',
            headers: getJsonHeaders(),
            body: JSON.stringify({ conversationId, messageIndex: msgIndex, value: val }),
          }).catch(() => {});
        }
      });
    });
    msgDiv.appendChild(fb);
  }

  function addMessage(role, content, withFeedback = false) {
    const div = document.createElement('div');
    div.className = `pv-msg pv-${role}`;
    if (role === 'user') {
      div.textContent = content;
    } else {
      div.innerHTML = renderMarkdown(content);
    }
    if (withFeedback) addFeedback(div, 0);
    msgs.insertBefore(div, suggestionsEl);
    scrollToBottom();
    return div;
  }

  // ─── Catálogo de productos (inyectado por Liquid) ──────────────────────
  const PRODUCT_CATALOG = window.__PV_PRODUCT_CATALOG__ || {};

  function renderProductCarousel(products) {
    const container = document.createElement('div');
    container.className = 'pv-carousel';

    products.forEach(function (p) {
      var catalogEntry = PRODUCT_CATALOG[p.handle] || {};
      var image = catalogEntry.image || '';
      var title = p.nombre || catalogEntry.title || p.handle;
      var price = p.precio || catalogEntry.price || '';
      var rawUrl = p.url || catalogEntry.url || '/products/' + p.handle;
      var url = rawUrl.replace(/^https?:\/\/[^\/]+/, '');

      const card = document.createElement('div');
      card.className = 'pv-carousel-card';

      var html = '';
      if (image) {
        html += '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy">';
      }
      html += '<div class="pv-carousel-body">';
      html += '<div class="pv-carousel-title">' + escapeHtml(title) + '</div>';
      html += '<div class="pv-carousel-price">' + escapeHtml(price) + '</div>';
      html += '<div class="pv-carousel-actions">';
      html += '<a href="' + escapeHtml(url) + '" class="pv-carousel-btn pv-carousel-btn-secondary">Ver producto</a>';
      html += '</div></div>';
      card.innerHTML = html;

      container.appendChild(card);
    });

    return container;
  }

  function renderOrderCards(orders) {
    var container = document.createElement('div');
    container.className = 'pv-order-cards';

    orders.forEach(function (order) {
      var card = document.createElement('div');
      card.className = 'pv-order-card';

      var statusClass = 'pv-order-status-prep';
      if (order.fulfillmentStatus === 'Enviado') statusClass = 'pv-order-status-shipped';
      else if (order.financialStatus === 'Pagado') statusClass = 'pv-order-status-paid';

      var html = '<div class="pv-order-header">';
      html += '<span class="pv-order-name">' + escapeHtml(order.name) + '</span>';
      html += '<span class="pv-order-total">' + escapeHtml(order.total) + '</span>';
      html += '</div>';
      html += '<div class="pv-order-date">' + escapeHtml(order.date) + '</div>';
      html += '<div class="pv-order-statuses">';
      html += '<span class="pv-order-badge ' + statusClass + '">' + escapeHtml(order.fulfillmentStatus) + '</span>';
      html += '<span class="pv-order-badge">' + escapeHtml(order.financialStatus) + '</span>';
      html += '</div>';

      if (order.items && order.items.length > 0) {
        html += '<div class="pv-order-items">';
        order.items.forEach(function (item) {
          html += '<div class="pv-order-item">' + escapeHtml(item.title) + ' ×' + item.quantity + '</div>';
        });
        html += '</div>';
      }

      if (order.trackingUrl) {
        html += '<a href="' + escapeHtml(order.trackingUrl) + '" class="pv-carousel-btn pv-carousel-btn-primary" target="_blank" rel="noopener">📦 Seguimiento SEUR</a>';
      }

      card.innerHTML = html;
      container.appendChild(card);
    });

    return container;
  }

  function showTyping() {
    const el = document.createElement('div');
    el.className = 'pv-typing';
    el.id = 'pv-typing';
    el.innerHTML = '<span></span><span></span><span></span><span class="pv-typing-text">' + escapeHtml(UI_COPY.typing) + '</span>';
    msgs.insertBefore(el, suggestionsEl);
    scrollToBottom();
    return el;
  }

  function removeTyping() {
    const el = document.getElementById('pv-typing');
    if (el) el.remove();
    scrollToBottom(true);
  }

  function setLoading(loading) {
    isStreaming = loading;
    sendBtn.disabled = loading;
    sendBtn.classList.toggle('pv-sending', loading);
    sendBtn.setAttribute('aria-busy', String(loading));
    input.disabled = loading;
    input.setAttribute('aria-busy', String(loading));
    const statusEl = document.querySelector('#pv-chat-header .pv-status');
    if (statusEl) statusEl.textContent = loading ? UI_COPY.statusTyping : UI_COPY.statusAvailable;
  }

  // ─── Inicializar sugerencias ──────────────────────────────────────────────
  function buildSuggestions() {
    if (!suggestionsEl) return;
    suggestionsEl.innerHTML = '';
    const header = document.createElement('div');
    header.className = 'pv-suggestions-header';
    header.innerHTML = '<span class="pv-suggestions-label">Pregúntame lo que quieras, o elige una opción 👇</span>';
    const closeBtn = document.createElement('button');
    closeBtn.className = 'pv-suggestions-close';
    closeBtn.setAttribute('aria-label', 'Cerrar sugerencias');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', () => {
      suggestionsEl.classList.add('pv-hidden');
    });
    header.appendChild(closeBtn);
    suggestionsEl.appendChild(header);
    SUGGESTIONS.forEach((text) => {
      const chip = document.createElement('button');
      chip.className = 'pv-chip';
      chip.textContent = text;
      chip.setAttribute('aria-label', 'Enviar: ' + text);
      chip.addEventListener('click', () => {
        if (isStreaming) return;
        input.value = text;
        handleSend();
      });
      suggestionsEl.appendChild(chip);
    });
  }

  function renderDynamicSuggestions(suggestions) {
    if (!suggestionsEl || !suggestions.length) return;

    // Clear previous suggestions
    suggestionsEl.innerHTML = '';

    // Add close button
    const header = document.createElement('div');
    header.className = 'pv-suggestions-header';
    header.innerHTML = '<span class="pv-suggestions-label">Preguntas relacionadas</span>';
    const closeBtn = document.createElement('button');
    closeBtn.className = 'pv-suggestions-close';
    closeBtn.setAttribute('aria-label', 'Cerrar sugerencias');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', () => {
      suggestionsEl.classList.add('pv-hidden');
    });
    header.appendChild(closeBtn);
    suggestionsEl.appendChild(header);

    // Add dynamic chips
    suggestions.forEach((text) => {
      const chip = document.createElement('button');
      chip.className = 'pv-chip pv-chip-dynamic';
      chip.textContent = text;
      chip.setAttribute('aria-label', 'Enviar: ' + text);
      chip.addEventListener('click', () => {
        if (isStreaming) return;
        input.value = text;
        handleSend();
      });
      suggestionsEl.appendChild(chip);
    });

    // Show with animation
    suggestionsEl.classList.remove('pv-hidden');
    suggestionsEl.style.animation = 'pvMsgIn 0.25s ease';
    setTimeout(() => {
      suggestionsEl.style.animation = '';
      scrollToBottom(true);
    }, 300);
  }

  // D: Restaurar historial con tarjetas de producto
  function restoreHistory() {
    history.forEach(function (m) {
      var div = addMessage(m.role === 'user' ? 'user' : 'bot', m.displayContent || m.content);
      if (m.products && Array.isArray(m.products) && m.products.length > 0) {
        div.appendChild(renderProductCarousel(m.products));
      }
    });
    scrollToBottom(true);
  }

  function addWelcomeMessage() {
    // Primer mensaje: saludo + código descuento
    const div = addMessage('bot', `✨ ¡Hola! Soy **Pura**, tu asistente de **Puravida Lash**.\n\n🎁 Usa el código **${WELCOME_CODE}** y consigue **${WELCOME_DISCOUNT} de descuento** en tu pedido.`);
    const btn = document.createElement('button');
    btn.className = 'pv-copy-code';
    btn.textContent = `Copiar código ${WELCOME_CODE} 📋`;
    btn.addEventListener('click', () => {
      navigator.clipboard.writeText(WELCOME_CODE).then(() => {
        btn.textContent = '✅ ¡Código copiado!';
        btn.classList.add('pv-copy-done');
        setTimeout(() => {
          btn.textContent = `Copiar código ${WELCOME_CODE} 📋`;
          btn.classList.remove('pv-copy-done');
        }, 2500);
      }).catch(() => {
        btn.textContent = `${WELCOME_CODE} — cópialo manualmente`;
      });
    });
    div.appendChild(btn);

    // Segundo mensaje: contexto de página + CTA
    const product = getCurrentProduct();
    const collection = getCurrentCollection();
    const article = getCurrentBlogArticle();
    var contextMsg = '';
    if (product) {
      contextMsg = `Veo que estás mirando **${product.name}** — ¡excelente elección! ¿Te cuento qué lo hace especial? 💚`;
    } else if (collection) {
      contextMsg = `Estás explorando **${collection.name}** — ¿te ayudo a encontrar lo que necesitas? 💚`;
    } else if (article) {
      contextMsg = `Estás leyendo sobre **${article.name}** — ¿necesitas los productos para aplicar lo que aprendes? 💚`;
    } else {
      contextMsg = 'Estoy aquí para ayudarte a elegir productos, resolver dudas de envío o armar tu pedido. 🌸\n\n¿En qué puedo ayudarte? 💚';
    }
    addMessage('bot', contextMsg);
  }

  // ─── Skeleton loader (first open only) ───────────────────────────────────
  function showSkeleton() {
    const sk = document.createElement('div');
    sk.className = 'pv-skeleton';
    sk.innerHTML =
      '<div class="pv-skeleton-row"><div class="pv-skeleton-bubble pv-sk-long"></div></div>' +
      '<div class="pv-skeleton-row"><div class="pv-skeleton-bubble pv-sk-medium"></div></div>' +
      '<div class="pv-skeleton-row"><div class="pv-skeleton-bubble pv-sk-short"></div></div>';
    msgs.insertBefore(sk, suggestionsEl);
    return sk;
  }

  // ─── Toggle chat ──────────────────────────────────────────────────────────
  // Focus trap para WAI-ARIA dialog pattern
  function trapChatFocus(e) {
    if (!isOpen || e.key !== 'Tab') return;
    var focusable = win.querySelectorAll('button:not([disabled]), a[href], textarea:not([disabled]), input:not([disabled])');
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function setChatOpen(open) {
    isOpen = open;
    win.classList.toggle('pv-visible', open);
    win.setAttribute('aria-hidden', String(!open));
    win.toggleAttribute('inert', !open);
    btn.classList.toggle('pv-open', open);
    btn.setAttribute('aria-expanded', String(open));
  }

  function openChat(options = {}) {
    hydrateChatShell();
    if (options.opener) chatOpener = options.opener;
    setChatOpen(true);
    badge.classList.remove('pv-visible');
    document.getElementById('pv-mascota-img')?.style.setProperty('animation-play-state', 'paused');
    document.addEventListener('keydown', trapChatFocus);
    sessionStorage.setItem(CHAT_OPEN_KEY, '1');
    var mainEl = document.querySelector('main');
    if (mainEl) mainEl.setAttribute('inert', '');
    if (options.focus) {
      // En móvil enfocamos un control del diálogo sin abrir el teclado virtual.
      (window.innerWidth > 480 ? input : closeBtn || input).focus();
    }

    const hasMessages = msgs.querySelectorAll('.pv-msg').length > 0;
    if (!hasMessages && !openedFromMascota) {
      if (history.length > 0) {
        // FUNC-002: Restaurar historial guardado entre páginas
        restoreHistory();
      } else if (!localStorage.getItem(REGALO_KEY)) {
        const skeleton = showSkeleton();
        setTimeout(() => {
          skeleton.remove();
          localStorage.setItem(REGALO_KEY, '1');
          addWelcomeMessage();
          msgs.scrollTop = 0;
        }, 350);
      } else {
        const skeleton = showSkeleton();
        setTimeout(() => {
          skeleton.remove();
          addMessage('bot', getGreeting());
          msgs.scrollTop = 0;
        }, 350);
      }
    }
    openedFromMascota = false;
  }

  function closeChat(options = {}) {
    const opener = chatOpener;
    chatOpener = null;
    setChatOpen(false);
    document.getElementById('pv-mascota-img')?.style.setProperty('animation-play-state', 'running');
    document.removeEventListener('keydown', trapChatFocus);
    sessionStorage.removeItem(CHAT_OPEN_KEY);
    var mainEl = document.querySelector('main');
    if (mainEl) mainEl.removeAttribute('inert');
    if (options.restoreFocus !== false && opener?.isConnected && !opener.closest('[inert]')) opener.focus();
    // Reaparecer hada después de cerrar (sin el regalo si ya se vio)
    setTimeout(showMascota, 8000);
  }

  function clearChat() {
    // Limpiar historial y estado
    history.length = 0;
    conversationId = null;
    sessionStorage.removeItem(HISTORY_KEY);
    sessionStorage.removeItem(HISTORY_TS_KEY);
    clearLegacyLocalHistory();
    sessionStorage.removeItem('pv_conversation_id');
    sessionStorage.removeItem(LAST_PAGE_KEY);
    // Limpiar DOM — quitar todo EXCEPTO #pv-suggestions
    Array.from(msgs.children).forEach(function (child) {
      if (child !== suggestionsEl) child.remove();
    });
    input.disabled = false;
    sendBtn.disabled = false;
    input.placeholder = UI_COPY.inputPlaceholder;
    // Mostrar greeting fresco + sugerencias
    addMessage('bot', getGreeting());
    if (suggestionsEl) {
      suggestionsEl.classList.remove('pv-hidden');
      buildSuggestions();
    }
  }

  setChatOpen(false);

  btn.addEventListener('click', () => (isOpen ? closeChat() : openChat({ focus: true, opener: btn })));
  if (clearBtn) clearBtn.addEventListener('click', clearChat);
  if (closeBtn) closeBtn.addEventListener('click', () => closeChat());
  // ACC: Cerrar con Escape (WAI-ARIA pattern)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) closeChat();
  });

  // Mostrar badge después de 8s si el usuario no ha abierto el chat
  setTimeout(() => {
    if (!isOpen) badge.classList.add('pv-visible');
  }, 8000);

  // ─── Enviar mensaje ──────────────────────────────────────────────────────
  async function handleSend() {
    const text = input.value.trim();
    if (!text || isStreaming) return;

    // Cooldown con feedback visual
    const now = Date.now();
    if (now - lastSendTime < COOLDOWN_MS) {
      sendBtn.style.transform = 'scale(0.85)';
      setTimeout(function () { sendBtn.style.transform = ''; }, 200);
      return;
    }
    lastSendTime = now;

    // Límite de mensajes
    if (getUserMessageCount() >= MAX_MESSAGES) {
      const waUrl = buildWhatsAppUrl();
      const limitDiv = document.createElement('div');
      limitDiv.className = 'pv-msg pv-bot';
      limitDiv.innerHTML = `Has llegado al límite de mensajes. Continúa la conversación por WhatsApp y te ayudamos enseguida: <a href="${waUrl}" target="_blank" rel="noopener noreferrer">Abrir WhatsApp 💬</a>`;
      msgs.insertBefore(limitDiv, suggestionsEl);
      scrollToBottom(true);
      input.disabled = true;
      sendBtn.disabled = true;
      input.placeholder = 'Límite alcanzado · Escríbenos por WhatsApp';
      return;
    }

    // Aviso cuando quedan 3 mensajes
    var remaining = MAX_MESSAGES - getUserMessageCount();
    if (remaining === 3) {
      addMessage('bot', `Te quedan **3 mensajes**. Si necesitas más ayuda, puedes continuar por [WhatsApp](https://wa.me/${WHATSAPP.replace(/\\D/g, '')}) 💬`);
    }

    // Hide current suggestions immediately so they don't distract during streaming
    if (suggestionsEl) suggestionsEl.classList.add('pv-hidden');

    const previousHistory = history.slice();

    input.value = '';
    input.style.height = '38px';

    const userDiv = addMessage('user', text);

    // Hide suggestions on first user message (dynamic ones will appear from bot)
    const userMsgCount = msgs.querySelectorAll('.pv-msg.pv-user').length;
    if (userMsgCount >= 1) {
      if (suggestionsEl) suggestionsEl.classList.add('pv-hidden');
    }

    history.push({ role: 'user', content: text });
    // Limitar historial en storage a 20 mensajes para evitar crecimiento infinito
    while (history.length > 20) history.shift();
    saveHistory();

    function rollbackOptimisticUserMessage() {
      if (!userDiv.isConnected) return false;
      input.value = text;
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 90) + 'px';
      history.splice(0, history.length, ...previousHistory);
      saveHistory();
      userDiv.remove();
      return true;
    }

    setLoading(true);
    showTyping();

    try {
      const _ac = new AbortController();
      const _acTimer = setTimeout(() => _ac.abort(), 15000);
      let response;
      try {
        response = await fetch(`${API_URL}/api/chat`, {
          method: 'POST',
          headers: getJsonHeaders(),
          signal: _ac.signal,
          body: JSON.stringify({
            messages: history.slice(-10).map(toApiMessage),
            sessionId: SESSION_ID,
            pageUrl: window.location.pathname,
            productHandle: getCurrentProduct()?.handle || null,
            productStock: PRODUCT_STOCK,
          }),
        });
      } catch (fetchErr) {
        clearTimeout(_acTimer);
        if (fetchErr.name === 'AbortError') {
          removeTyping();
          if (!rollbackOptimisticUserMessage()) return;
          addMessage('bot', `La conexión tardó demasiado. Prueba de nuevo o [escríbenos por WhatsApp](${buildWhatsAppUrl()}) 💬`);
          return;
        }
        throw fetchErr;
      }
      clearTimeout(_acTimer);

      removeTyping();

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        if (!rollbackOptimisticUserMessage()) return;
        addMessage('bot', err.error || 'Ha habido un error. Por favor inténtalo de nuevo.');
        return;
      }

      // Leer SSE stream con timeout de 30s
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let botDiv = addMessage('bot', '');
      let fullText = '';
      let streamDone = false;
      let sseBuffer = '';
      let pendingOrderEl = null;
      let pendingProducts = null;

      const streamTimeout = setTimeout(() => {
        if (!streamDone) {
          reader.cancel();
          if (fullText) {
            botDiv.innerHTML = renderMarkdown(fullText) + '<span class="pv-msg-truncated"> ⚠️ Respuesta incompleta</span>';
          } else if (rollbackOptimisticUserMessage()) {
            botDiv.innerHTML = renderMarkdown(`La conexión tardó demasiado. Prueba de nuevo o [escríbenos por WhatsApp](${buildWhatsAppUrl()}) 💬`);
          }
        }
      }, 30000);

      try {
        while (true) {
          const { done, value } = await reader.read();
          sseBuffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
          const lines = sseBuffer.split('\n');
          sseBuffer = done ? '' : (lines.pop() || '');
          for (const line of lines) {
            if (!line.startsWith('data: ')) continue;
            const data = line.slice(6).trim();
            if (data === '[DONE]') { streamDone = true; break; }
            if (data === '[ERROR]') {
              if (rollbackOptimisticUserMessage()) {
                botDiv.innerHTML = renderMarkdown('Ha habido un error. Por favor inténtalo de nuevo.');
              }
              streamDone = true;
              break;
            }
            try {
              const parsed = JSON.parse(data);
              if (parsed.conversationId) {
                conversationId = parsed.conversationId;
                sessionStorage.setItem('pv_conversation_id', conversationId);
              }
              if (parsed.chunk) {
                fullText += parsed.chunk;
                botDiv.innerHTML = renderMarkdown(fullText);
                scrollToBottom(true);
              }
              if (parsed.orders && Array.isArray(parsed.orders) && parsed.orders.length > 0) {
                pendingOrderEl = renderOrderCards(parsed.orders);
              }
              if (parsed.products && Array.isArray(parsed.products) && parsed.products.length > 0) {
                pendingProducts = parsed.products;
                var carouselEl = renderProductCarousel(parsed.products);
                botDiv.appendChild(carouselEl);
                scrollToBottom(true);
              }
              if (parsed.suggestions && Array.isArray(parsed.suggestions)) {
                renderDynamicSuggestions(parsed.suggestions);
              }
            } catch (_) {}
          }
          if (streamDone || done) break;
        }
      } finally {
        clearTimeout(streamTimeout);
        streamDone = true;
      }

      if (!userDiv.isConnected) return;

      // Append buffered order cards (orders arrive before stream, can't append during)
      if (pendingOrderEl && fullText) {
        botDiv.appendChild(pendingOrderEl);
      }

      if (fullText) {
        var entry = { role: 'assistant', content: fullText };
        if (pendingProducts) entry.products = pendingProducts;
        history.push(entry);
        saveHistory();
        addFeedback(botDiv, history.length - 1);
        scrollToBottom(true);
      }
    } catch (err) {
      removeTyping();
      if (!rollbackOptimisticUserMessage()) return;
      addMessage('bot', 'Error de conexión. Comprueba tu internet e inténtalo de nuevo.');
      console.error('[PV Chat]', err);
    } finally {
      setLoading(false);
    }
  }

  // ─── Form submit ──────────────────────────────────────────────────────────
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    handleSend();
  });

  // Enter para enviar, Shift+Enter para nueva línea
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  });

  // Auto-resize textarea (debounced)
  let _resizeTimer;
  input.addEventListener('input', () => {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(() => {
      input.style.height = '38px';
      const newHeight = Math.min(input.scrollHeight, 90);
      input.style.height = newHeight + 'px';
      input.style.overflowY = newHeight >= 90 ? 'auto' : 'hidden';
    }, 50);
  });

  // ─── Teclado móvil: ajustar altura del chat cuando sube/baja el teclado ───
  let _viewportHandler = null;
  if (window.visualViewport) {
    _viewportHandler = () => {
      if (!isOpen || window.innerWidth > 480) return;
      const vh = window.visualViewport.height;
      const fullVh = window.innerHeight;
      if (vh < fullVh - 100) {
        win.style.height = vh + 'px';
        win.style.bottom = '0';
        scrollToBottom();
      } else {
        win.style.height = '';
        win.style.bottom = '';
      }
    };
    window.visualViewport.addEventListener('resize', _viewportHandler);
  }

  // Scroll al foco del input en móvil para ver los mensajes
  input.addEventListener('focus', () => {
    if (window.innerWidth <= 480) {
      setTimeout(scrollToBottom, 350);
    }
  });

  // Al perder el foco (teclado cierra) restaurar altura por si visualViewport no disparó
  input.addEventListener('blur', () => {
    if (window.innerWidth <= 480) {
      setTimeout(() => {
        win.style.height = '';
        win.style.bottom = '';
      }, 100);
    }
  });

  // ─── Cleanup on unload ───────────────────────────────────────────────────
  window.addEventListener('beforeunload', () => {
    _bodyObserver?.disconnect();
    _stickyObserver?.disconnect();
    if (_viewportHandler && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', _viewportHandler);
    }
  });

  // ─── Ocultar widget completo cuando abre menú o carrito ──────────────────
  function hideWidget() {
    if (isOpen) closeChat({ restoreFocus: false });
    hideMascota();
    btn.style.display = 'none';
  }
  function showWidget() {
    btn.style.display = '';
  }

  document.addEventListener('cart:open', () => {
    document.body.classList.add('pv-cart-open');
    hideWidget();
  });
  document.addEventListener('cart:close', () => {
    document.body.classList.remove('pv-cart-open');
    showWidget();
  });

  // El menú añade 'overflow-hidden-mobile' o 'overflow-hidden-tablet'; el carrito 'overflow-hidden'
  const _bodyObserver = new MutationObserver(() => {
    const cls = document.body.className;
    if (cls.includes('overflow-hidden')) {
      hideWidget();
    } else {
      showWidget();
    }
  });
  _bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  let _stickyObserver = null;

  // ─── Offset en PDP: solo cuando el sticky add-to-cart es visible ──────────
  if (window.location.pathname.includes('/products/') && window.innerWidth <= 480) {
    const stickyAtc = document.querySelector('.sticky-atc');
    if (stickyAtc) {
      // El sticky cambia aria-hidden cuando aparece/desaparece
      _stickyObserver = new MutationObserver(() => {
        const visible = stickyAtc.getAttribute('aria-hidden') === 'false';
        document.body.classList.toggle('pv-is-product', visible);
      });
      _stickyObserver.observe(stickyAtc, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  // ─── Popup mascota ────────────────────────────────────────────────────────
  const mascotaPopup = document.getElementById('pv-mascota-popup');
  const mascotaClose = document.getElementById('pv-mascota-close');
  const mascotaImg   = document.getElementById('pv-mascota-img');
  const mascotaBubble = document.getElementById('pv-mascota-bubble');

  function setMascotaVisible(visible) {
    if (!mascotaPopup) return;
    mascotaPopup.classList.toggle('pv-visible', visible);
    mascotaPopup.setAttribute('aria-hidden', String(!visible));
    mascotaPopup.toggleAttribute('inert', !visible);
  }

  setMascotaVisible(false);

  // Preguntas rotativas para el bocadillo (tras el regalo) — contextuales
  function getBubbleQuestions() {
    const product = getCurrentProduct();
    if (product) {
      return product.bubble || [
        `¿Dudas sobre ${product.name}? 💬`,
        'Te ayudo a elegir 💚',
        '¿Te asesoro? 💚',
      ];
    }

    const collection = getCurrentCollection();
    if (collection) {
      return collection.bubble;
    }

    const page = getCurrentPage();
    if (page) {
      return page.bubble;
    }

    const article = getCurrentBlogArticle();
    if (article) {
      return article.bubble;
    }

    const path = window.location.pathname;
    if (path.includes('/cart') || path.includes('/checkout'))
      return ['¿Llegas al envío gratis? 📦', '¿Código aplicado? 🎁', '¿Necesitas añadir algún básico?'];
    return [
      'Los más vendidos del mes 🔥',
      'Productos destacados 🌸',
      '¿Te asesoro gratis? 💚',
      '¡Envío gratis desde 50€! 📦',
    ];
  }
  const BUBBLE_QUESTIONS = getBubbleQuestions();
  let _bubbleRotateTimer = null;

  function startBubbleRotation() {
    if (!mascotaBubble) return;
    const title = mascotaBubble.querySelector('.pv-mb-title');
    if (!title) return;
    if (_bubbleRotateTimer) { clearTimeout(_bubbleRotateTimer); _bubbleRotateTimer = null; }

    let idx = 0;
    mascotaBubble.style.transition = 'opacity 0.35s ease';

    function nextQuestion() {
      if (!mascotaPopup.classList.contains('pv-visible') || isOpen) return;

      // 1. Ocultar bocadillo entero
      mascotaBubble.style.opacity = '0';

      // 2. Tras fade out, ocultar y esperar 7s
      _bubbleRotateTimer = setTimeout(() => {
        mascotaBubble.style.visibility = 'hidden';
        idx = (idx + 1) % BUBBLE_QUESTIONS.length;
        title.textContent = BUBBLE_QUESTIONS[idx];

        // 3. Tras 7s, mostrar bocadillo con nuevo texto
        _bubbleRotateTimer = setTimeout(() => {
          mascotaBubble.style.visibility = 'visible';
          mascotaBubble.style.opacity = '1';

          // 4. Visible 3s, luego repetir
          _bubbleRotateTimer = setTimeout(nextQuestion, 3000);
        }, 7000);
      }, 350);
    }

    // Primera rotación tras 3s visible
    _bubbleRotateTimer = setTimeout(nextQuestion, 3000);
  }

  function showMascota() {
    // En la home editorial, mantener solo el acceso manual al chat.
    if (document.querySelector('[data-pvl-stage]')) return;
    if (localStorage.getItem(MASCOTA_KEY)) return;
    if (isOpen) return;
    if (!mascotaPopup) return;

    const regaloVisto = localStorage.getItem(REGALO_KEY);
    const title = mascotaBubble ? mascotaBubble.querySelector('.pv-mb-title') : null;

    if (regaloVisto) {
      // Regalo ya visto: mostrar preguntas rotativas directamente
      if (title) title.textContent = BUBBLE_QUESTIONS[0];
      if (mascotaBubble) mascotaBubble.style.display = '';
      setMascotaVisible(true);
      setTimeout(startBubbleRotation, 3500);
    } else {
      // Primera visita: mostrar el regalo fijo hasta que abra o cierre el chat
      if (title) title.textContent = UI_COPY.mascotGift;
      if (mascotaBubble) mascotaBubble.style.display = '';
      setMascotaVisible(true);
      // Sin rotación — el bocadillo queda fijo hasta interacción
    }
  }

  function hideMascota() {
    setMascotaVisible(false);
    if (_bubbleRotateTimer) { clearTimeout(_bubbleRotateTimer); _bubbleRotateTimer = null; }
  }

  function openChatFromMascota() {
    hideMascota();
    openedFromMascota = true;
    const regaloVisto = localStorage.getItem(REGALO_KEY);
    openChat({ focus: true, opener: btn });

    setTimeout(() => {
      if (msgs.querySelectorAll('.pv-msg').length === 0) {
        if (history.length > 0) {
          // BUG-01: Restaurar historial guardado cuando se abre desde la mascota
          history.forEach((m) => addMessage(m.role === 'user' ? 'user' : 'bot', m.displayContent || m.content));
          scrollToBottom(true);
        } else if (!regaloVisto) {
          const skeleton = showSkeleton();
          setTimeout(() => {
            skeleton.remove();
            localStorage.setItem(REGALO_KEY, '1');
            addWelcomeMessage();
            msgs.scrollTop = 0;
          }, 350);
        } else {
          const skeleton = showSkeleton();
          setTimeout(() => {
            skeleton.remove();
            addMessage('bot', getGreeting());
            msgs.scrollTop = 0;
          }, 350);
        }
      }
    }, 200);
  }

  if (mascotaClose) {
    mascotaClose.addEventListener('click', (e) => {
      e.stopPropagation();
      hideMascota();
      localStorage.setItem(MASCOTA_KEY, '1');
    });
  }

  if (mascotaImg) mascotaImg.addEventListener('click', openChatFromMascota);
  if (mascotaBubble) {
    mascotaBubble.addEventListener('click', openChatFromMascota);
    mascotaBubble.addEventListener('keydown', (e) => {
      if (e.target !== mascotaBubble) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;

      e.preventDefault();
      openChatFromMascota();
    });
  }

  // ─── Home (landing v3): retraso de widgets flotantes ─────────────────────
  // En la home el trío hada + bocadillo + botón no debe competir con el hero
  // editorial: el CSS (puravida-chat.css) los mantiene ocultos hasta que el
  // body recibe .pv-widgets-revealed. Umbral: ~80% del primer viewport de
  // scroll — suficiente para considerar la intención de navegar. Fuera de la
  // home la clase del CSS no aplica y el comportamiento es el de siempre.
  (function setupHomeWidgetDelay() {
    if (!document.body.dataset.landingV3) return;
    // Si el chat venía abierto de la página anterior, revelar de inmediato
    // para no dejar la ventana huérfana sin su botón.
    if (sessionStorage.getItem(CHAT_OPEN_KEY) === '1') {
      document.body.classList.add('pv-widgets-revealed');
      return;
    }
    function onScroll() {
      if (window.scrollY < window.innerHeight * 0.8) return;
      document.body.classList.add('pv-widgets-revealed');
      window.removeEventListener('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Cubrir recargas con la página ya scrolleada (restauración del navegador).
    onScroll();
  })();

  // Aparece a los 4 segundos
  setTimeout(showMascota, 4000);

  // Ocultar mascota cuando se abre el chat manualmente
  btn.addEventListener('click', hideMascota, { once: false });

  // ─── Init ─────────────────────────────────────────────────────────────────
  buildSuggestions();

  // B: Auto-abrir si el chat estaba abierto en la página anterior
  if (sessionStorage.getItem(CHAT_OPEN_KEY) === '1') {
    openChat();
  }
})();
